module.exports = __webpack_public_path__ + "static/ipad-cover-photo-3ddb857bd7b5c865d688547a4ff56dd6.webp";